module.exports = __webpack_public_path__ + "img/Logo-TESS-ASIA.199ac59f.webp";